import { createSlice } from '@reduxjs/toolkit';
import licenseEndpoint from 'app/api/services/licenseEndpoint';
import { errorHandler } from 'app/utils/errorHandler';

const initialState = {
  licenseChangeTypes: [],
  fixedGroups: [],
};

const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    setLicenseChangeTypes(state, action) {
      state.licenseChangeTypes = action.payload;
    },
    clearLicenseChangeTypes(state, action) {
      state.licenseChangeTypes = initialState.licenseChangeTypes;
    },
    setFixedGroups(state, action) {
      state.fixedGroups = action.payload;
    },
    clearFixedGroups(state, action) {
      state.fixedGroups = initialState.fixedGroups;
    },
  },
});

export const fecthLicenseChangeTypes = () => async dispatch => {
  try {
    const response = await licenseEndpoint.getLicenseChangeTypes();
    if (response.status === 200 && response.data) {
      dispatch(setLicenseChangeTypes(response.data));
    }
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const fecthFixedGroups = () => async dispatch => {
  try {
    const response = await licenseEndpoint.getFixedGroups();
    if (response.status === 200 && response.data) {
      dispatch(setFixedGroups(response.data));
    }
  } catch (error) {
    errorHandler(error.response?.status, error.response?.data?.message);
  }
};

export const {
  setLicenseChangeTypes,
  clearLicenseChangeTypes,
  setFixedGroups,
  clearFixedGroups
} = licenseSlice.actions;

export default licenseSlice;
